import { render } from "./index.vue?vue&type=template&id=4e57979a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "../forum/css/antd.css?vue&type=style&index=0&lang=css"
import "./index.vue?vue&type=style&index=1&id=4e57979a&lang=css"
import "./index.vue?vue&type=style&index=2&id=4e57979a&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e57979a"]])

export default __exports__